module.exports = __webpack_public_path__ + "img/logo-xs.018f79ba.png";